import moment from 'moment';
import React, { useState, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import { Icon, DataTable, Form, Heading6 } from '../components/widgets';
import { uuid } from '../helpers/common';
import { getUserId } from '../helpers/session';
import { dateUTCToTimezone } from '../helpers/moment-ex';
import { DISPLAY_DATETIME_FORMAT2 } from '.';
import { uploadToGoogle } from '../helpers/web-agent';
import { getLoadSamplerUploadURL, getLoadSamplerRetrieveURL } from './utils';


const LoadSample = props => {
	const { show, onHide, load, farmId, saveSample } = props;

	const farmSettings = useSelector(state => state.farm.farmSettings.farm_config);
	const planTypeId = useSelector(state => state.plan.selectedPlanType);
	const { seed_load_sample: { /* allowMultiple: isRepeat, */ configuration: { seed_load_sample_params = [], add_title, edit_title, view_title } = {} } = {} } = farmSettings || {};

	const loadSamples = useMemo(() => load && load["seed_sample"] ?
		load["seed_sample"].map((e) => ({ ...e, id: e.id ? e.id : planTypeId === 4 ? Date.now() : uuid() })) : [], [load]);

	const [isAdd, setAdd] = useState(true);
	const [isDelete, setDelete] = useState(false);
	const [loadSample, setLoadSample] = useState(getSampleRow())
	const [loadSampleList, setLoadSampleList] = useState(loadSamples);
	const [editSampleId, setEditSample] = useState(null)
	const [samplerFiles, setSamplerFiles] = useState([]);
	const [samplerFileURL, setSamplerFileURL] = useState([]);

	const currentDate = moment().utc().format();


	useEffect(() => { if (loadSampleList.length > 0) setAdd(false) }, []);

	function getSampleRow() {
		const initialFormState = {};
		seed_load_sample_params.forEach(item => {
			initialFormState[item.key] = "";
			initialFormState['created_by'] = null;
			initialFormState['created_date'] = null;
			initialFormState['modified_by'] = null;
			initialFormState['modified_date'] = null;
			initialFormState['files_url'] = [];
			initialFormState['id'] = planTypeId === 4 ? Date.now() : uuid();
		});

		return initialFormState
	}

	const handleDynamicValue = (type, key, value) => {
		let newValue = null;
		if (type === 'options') {
			newValue = value && value.value !== undefined ? value.value : null;
		} else if (type === 'number') {
			newValue = value.trim() !== '' ? Number(value.trim()) : '';
		} else {
			newValue = (type === 'string') ? value.trim() : value
		}
		setLoadSample({ ...loadSample, [key]: newValue });
	}

	const handleFileChange = (event) => {
		const files = event.target.files;
		if (files && files.length > 0) {
			setSamplerFiles(prevFiles => [...prevFiles, ...files]);
			const urls = Array.from(files).map(file => URL.createObjectURL(file));

			setSamplerFileURL(prevUrls => [...prevUrls, ...urls]);
		}
	};

	const handleDelete = async (sampleId) => {
		const deleted = loadSampleList.filter((e) => e.id !== sampleId)
		setLoadSampleList(deleted);
		await saveLoadSample(deleted);
		setDelete(false);
	}

	const handleEdit = (sampleId) => {
		setAdd(true);
		setEditSample(sampleId);
		const find = loadSampleList.find((e) => e.id === sampleId);
		if (find) {
			setLoadSample(find);
			const fileURL = find.files_url ? find.files_url : [];
			setSamplerFileURL(fileURL);
		}
	}

	const handleSave = async () => {

		const samplerFiles = await saveSamplerFiles();

		if (editSampleId) {
			const findIndex = loadSampleList.findIndex(e => e.id === editSampleId);
			const updated = findIndex !== -1 ? loadSampleList.map((e, index) => {
				if (index === findIndex) return {
					...loadSample,
					files_url: e.files_url ? [...e.files_url, ...samplerFiles] : [],
					modified_by: getUserId(),
					modified_date: currentDate
				};
				else return e;
			}) : [];

			await saveLoadSample(updated);
			setLoadSampleList(updated)
		} else {
			if (loadSample.cutter_type && loadSample.cutter_type.toString().trim().length > 0) {
				let newSample = {
					...loadSample,
					files_url: samplerFiles,
					created_by: getUserId(),
					created_date: currentDate
				}
				await saveLoadSample([...loadSampleList, newSample]);
				setLoadSampleList((e) => [...e, newSample]);

			}
		}

		if (loadSampleList.length > 0) setAdd(false);
		resetState();
	}

	const saveLoadSample = async (samples) => {
		let saveLoad = {
			load_activity_uuid: load.load_activity_uuid,
			farm_uuid: load.farm_uuid
		}
		if (samples.length > 0) {
			return await saveSample({
				...saveLoad,
				"seed_sample": samples
			});
		}
		else return;

	}

	const resetState = () => {
		setLoadSample(getSampleRow());
		setEditSample(null);
		setDelete(false);
		setSamplerFiles([]);
		setSamplerFileURL([]);
	}

	const saveSamplerFiles = async () => {
		const attachments = samplerFiles.map((e) => {
			const exe = e.name.split('.').pop();
			return {
				file: e,
				name: `${uuid()}.${exe}`,
			}
		});
		const fileURL = [];
		for (const attachment of attachments) {
			const res = await uploadToGoogle({ attachment, uploadUrl: getLoadSamplerUploadURL(farmId, getUserId()) });
			if (res.status === 200) {
				const url = `${getLoadSamplerRetrieveURL(farmId, getUserId())}/${attachment.name}`;
				fileURL.push(url);
			}
		}
		return fileURL;
	};

	return (<Modal show={show} onHide={onHide} className={`modal-form load_sample_container ${!isAdd ? 'seed-cutter-modal' : ''}`} size={`${!isAdd ? 'xl' : 'lg'}`} >
		<Form className="eg-form load-modal">
			<Modal.Header closeButton>
				<Modal.Title>
					<Heading6>{isAdd && !editSampleId ? add_title : editSampleId ? edit_title : view_title}</Heading6>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="py-0">
				{isAdd ? <AddLoadSample
					seedLoadSampleParams={seed_load_sample_params}
					handleDynamicValue={handleDynamicValue}
					loadSample={loadSample}
					handleFileChange={handleFileChange}
					samplerFileURL={samplerFileURL}
				/>
					: <LoadSampleTable
						loadSampleList={loadSampleList}
						seedLoadSampleParams={seed_load_sample_params}
						handleDelete={handleDelete}
						handleEdit={handleEdit}
					/>}
			</Modal.Body>
			<Modal.Footer>
				<Button size="sm" variant="danger" onClick={onHide}>
					<Icon className="fa fa-ban" /> Close
				</Button>

				{loadSampleList.length > 0 && isAdd && <Button size="sm" variant="secondary" onClick={() => {
					setAdd(false)
					resetState()
				}} >
					<Icon className="fa fa-arrow-left" /> Back
				</Button>}

				{!isAdd && !isDelete && <Button size="sm" variant="success" onClick={() => setAdd(true)}>
					<Icon className="fa fa-plus-circle" /> {add_title}
				</Button>}

				{(isAdd || isDelete) && <Button size="sm" variant="primary" onClick={() => handleSave()} >
					<Icon className="fa fa-floppy-o" /> {false ? "Saving..." : "Save"}
				</Button>}
			</Modal.Footer>
		</Form>
	</Modal >)
}

const AddLoadSample = props => {
	const { seedLoadSampleParams, handleDynamicValue, loadSample, handleFileChange, samplerFileURL } = props;

	return (
		<Row className={`pr-2 seedSample_row`}>
			{
				seedLoadSampleParams.sort((a, b) => a - b).filter((e) => e.visible).map((item, index) => {
					const keyValue = item.key;
					const dropDownOptions = (Array.isArray(item.values) && item.values.length > 0)
						? item.values.map((elm) => {
							return { value: elm, label: elm }
						}) : []
					return (
						<Col sm={12} md={6} lg={6} key={index} >
							<Form.Group key={keyValue}>
								<Form.Label htmlFor={item.type === 'options' ? '' : (keyValue + index)}>{item.label} {item.required ? <small className="error-mand ml-1">*</small> : null}   </Form.Label>
								{item.type === 'options' ? (
									<Form.Select
										aria-label={keyValue + index}
										menuPortalTarget={document.body}
										id={keyValue + index}
										placeholder={`Select ${item.label}`}
										name={keyValue}
										value={loadSample[item.key]}
										onChange={(e) => handleDynamicValue(item.type, keyValue, e)}
										options={dropDownOptions}
										classNamePrefix="modal_dropdowm_select"
									/>

								) : (
									<Form.Control
										id={keyValue + index}
										value={loadSample[item.key] ? loadSample[item.key] : ""}
										type={item.type}
										placeholder={`Enter ${item.label}`}
										className="form-control"
										autoComplete="off"
										name={keyValue}
										onChange={i => handleDynamicValue(item.type, keyValue, i.target.value)}
									/>
								)}
							</Form.Group>
						</Col>
					)
				})
			}
			<Col lg='12'>
				<div className='seed_sample_upload'>
					{samplerFileURL.map((url, index) => (
						<div key={index} className={`seed_upload_img_list`}>
							<img src={url} alt={`Uploaded ${index + 1}`} />
						</div>
					))}
					<div className={`seed_upload_input ${samplerFileURL.length > 4 ? 'disabled' : ''}`}>
						<input type="file" id="fileInput" multiple onChange={handleFileChange} style={{ display: 'none' }} />
						<label htmlFor="fileInput">Choose File</label>
					</div>
				</div>
			</Col>
		</Row >
	)
}

const LoadSampleTable = props => {
	const { loadSampleList, seedLoadSampleParams, handleDelete, handleEdit } = props;
	const timezoneIdentifier = useSelector((state) => state.farm.currentFarm.timezone_identifier);

	const headerLng = loadSampleList && loadSampleList.length > 0 ?
		loadSampleList.map((e, index) => ({ id: index, length: Object.keys(e).length }))
			.sort((a, b) => b.length - a.length) : [];

	const headerKey = headerLng.length > 0 ? [
		...Object.keys(loadSampleList[headerLng[0].id])
			.filter(key => !["created_by", "created_date", "created_by_name", "modified_by", "modified_by_name", "modified_date", "id", "sample_count"].includes(key)),
		"created_by_name",
		"created_date",
		"modified_by_name",
		"modified_date"] : [];


	const samplerHeaders = useMemo(() => {
		return headerKey.map((e, index) => {
			const find = seedLoadSampleParams.find((item) => item.key === e);
			if (find) return { key: e, label: find.label, display_order: find.display_order };
			return { key: e, label: e.split("_").join(" "), display_order: seedLoadSampleParams.length + index }
		}).sort((a, b) => a.display_order - b.display_order);
	}, [seedLoadSampleParams]);

	return (
		<DataTable>
			<DataTable.Header>
				<DataTable.Row>
					<DataTable.Cell style={{ width: '30px' }}>#</DataTable.Cell>
					{samplerHeaders.map((header, index) => (
						<DataTable.Cell className={"text-capitalize"} key={index}>{header.label}</DataTable.Cell>
					))}
					<DataTable.Cell>Action</DataTable.Cell>
				</DataTable.Row>
			</DataTable.Header>
			<DataTable.Body>
				{loadSampleList.map((item, index) => (
					<DataTable.Row key={index}>
						<DataTable.Cell style={{ width: '40px' }}>{index + 1}</DataTable.Cell>
						{samplerHeaders.map((header, idx) => (
							<DataTable.Cell key={idx}>{item[header.key] === null || item[header.key] === '' ? <span className='text-danger'>Unknown</span> : ["created_date", "modified_date"].includes(header.key)
								? dateUTCToTimezone(item[header.key], timezoneIdentifier).format(DISPLAY_DATETIME_FORMAT2) : header.key === "files_url" ? item[header.key] && item[header.key].length > 0
									? item[header.key].map((url, index) => (
										<React.Fragment key={index}><a href={url} target='_blank' rel="noopener noreferrer" >Sample {index + 1}</a> <br /></React.Fragment>
									)) : "N/A"
									: item[header.key]}</DataTable.Cell>
						))}
						<DataTable.Cell>
							<div className={`table_sample_btn`}>
								{item.hasOwnProperty('created_date') && item.created_date !== null && <Button className={`sample_edit_btn`}><Icon className={`fa fa-pencil`} title="Edit" onClick={() => handleEdit(item.id)}></Icon></Button>}
								{(index > 0) ? <Button className='sample_del_btn'><i className="fa fa-minus-circle" aria-hidden="true" onClick={() => handleDelete(item.id)}></i></Button> : null}
							</div>
						</DataTable.Cell>
					</DataTable.Row>
				))}
			</DataTable.Body>
		</DataTable>
	)
}

export default LoadSample;
